import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  inject
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Address, Site } from 'src/app/classes/models';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-site-details',
  templateUrl: './site-details.component.html',
  styleUrls: ['./site-details.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SiteDetailsComponent implements OnDestroy {
  private _cdr = inject(ChangeDetectorRef);

  constructor(
    private SharedDataService: SharedDataService,
    private Router: Router,
    private ToastService: ToastService
  ) {
    this.sharedDataServiceSubscription = this.SharedDataService.listenForEvent<
      Site | boolean | undefined
    >().subscribe({
      next: ({ eventName, data }) => {
        if (eventName === 'setSiteData' && data instanceof Site) {
          this.Site = data;

          const { CompanyId } = this.Site;

          if (!CompanyId) {
            throw this.ToastService.addErrorToast(
              'Error',
              'Missing Client Id.',
              { returnError: true }
            );
          }

          this.CompanyId = CompanyId;

          if (this.Site) {
            const { StreetAddress } = this.Site;

            if (StreetAddress) {
              this.siteAddress = StreetAddress;
            }
          }
          this._cdr.markForCheck();
        }

        if (
          eventName === 'setHasEditPermissions' &&
          typeof data === 'boolean'
        ) {
          this.hasEditPermissions = data;
          this._cdr.markForCheck();
        }
      }
    });

    this.SharedDataService.sendEvent('getHasEditPermissions');
    this.SharedDataService.sendEvent('getSiteData');
  }

  CompanyId!: number;
  Site!: Site;
  siteAddress?: Address;
  sharedDataServiceSubscription!: Subscription;
  hasEditPermissions: boolean = false;

  createQSB() {
    this.Router.navigate([
      'client',
      this.CompanyId,
      'proposal-request',
      'site',
      this.Site.id,
      'site-selection'
    ]);
  }

  editDetails() {
    this.SharedDataService.sendEvent('editSiteDetails');
  }

  ngOnDestroy(): void {
    this.sharedDataServiceSubscription.unsubscribe();
  }
}
